/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_change_region = /** @type {(inputs: {}) => string} */ () => {
	return `Změnit region/stát`
};

const da_change_region = /** @type {(inputs: {}) => string} */ () => {
	return `Skift region/stat`
};

const de_change_region = /** @type {(inputs: {}) => string} */ () => {
	return `Region/Bundesland wechseln`
};

const en_change_region = /** @type {(inputs: {}) => string} */ () => {
	return `Change region/state`
};

const es_change_region = /** @type {(inputs: {}) => string} */ () => {
	return `Cambiar región/estado`
};

const fr_change_region = /** @type {(inputs: {}) => string} */ () => {
	return `Changer de région/état`
};

const hu_change_region = /** @type {(inputs: {}) => string} */ () => {
	return `Régió/Állam módosítása`
};

const it_change_region = /** @type {(inputs: {}) => string} */ () => {
	return `Cambia regione/stato`
};

const nl_change_region = /** @type {(inputs: {}) => string} */ () => {
	return `Regio/staat wijzigen`
};

const pl_change_region = /** @type {(inputs: {}) => string} */ () => {
	return `Zmień region/województwo`
};

const pt_change_region = /** @type {(inputs: {}) => string} */ () => {
	return `Alterar região/estado`
};

const sv_change_region = /** @type {(inputs: {}) => string} */ () => {
	return `Byt region/stat`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const change_region = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.change_region(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("change_region", locale)
	if (locale === "cs") return cs_change_region(inputs)
	if (locale === "da") return da_change_region(inputs)
	if (locale === "de") return de_change_region(inputs)
	if (locale === "en") return en_change_region(inputs)
	if (locale === "es") return es_change_region(inputs)
	if (locale === "fr") return fr_change_region(inputs)
	if (locale === "hu") return hu_change_region(inputs)
	if (locale === "it") return it_change_region(inputs)
	if (locale === "nl") return nl_change_region(inputs)
	if (locale === "pl") return pl_change_region(inputs)
	if (locale === "pt") return pt_change_region(inputs)
	return sv_change_region(inputs)
};